import CheckSettingPage from './check-setting.page.vue'

let routes = [
  {
    path: '/check-setting',
    name: 'check-setting',
    component: CheckSettingPage
  },
]

export default routes
